/**
 * Persisted collapse/expand state for the AppShell sidebar's accordion
 * section groups (see AppShell.tsx). Every read/write is wrapped — private
 * browsing, a full quota, or no `window` at all (this module's callers
 * render under vitest's `environment: 'node'`, where `window` frequently
 * doesn't exist) must all fall back to "nothing collapsed", which is the
 * pre-accordion behavior every section always expanded.
 */
const STORAGE_KEY = 'sourcito.sidebar.collapsedSections';

export function loadCollapsedSections(): Set<string> {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((value): value is string => typeof value === 'string'));
  } catch {
    return new Set();
  }
}

export function saveCollapsedSections(sections: Set<string>): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...sections]));
  } catch {
    // Storage unavailable — collapse state just won't persist across
    // reloads; not fatal.
  }
}
